import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PageUnderConstruction = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    navigate("/login");
  };

  // Extract menu name from path
  const getMenuName = () => {
    const path = location.pathname;
    if (!path) return 'This page';

    // Convert path to readable format
    const parts = path.split('/');
    const lastPart = parts[parts.length - 1];

    if (!lastPart) return 'This page';

    // Convert kebab-case to Title Case
    return lastPart
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80vh',
          textAlign: 'center',
          padding: 3
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 5,
          }}
        >
          <ConstructionIcon sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
          <Typography variant="h3" component="h1" gutterBottom>
            Page Under Construction
          </Typography>
          <Typography variant="h6" color="text.secondary">
            {getMenuName()} is currently under development. Please check back later.
          </Typography>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={handleGoBack}
            sx={{ mt: 3 }}
          >
            Go Back
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default PageUnderConstruction;
